<template>
  <div
    :class="$style['v-hero']"
    v-background-color="colorBackground"
    v-background-image="getBackgroundImage"
  >
    <!-- <img
      v-if="showBackgroundImage"
      :class="$style['background-image']"
      :src="`https:${imageSource}`"
    />-->
    <slot :class="$style['slot']"></slot>
  </div>
</template>
<script>
export default {
  props: {
    colorBackground: {
      type: String,
      default: '',
    },
    imageSource: {
      type: String,
      default: '',
    },
    showBackgroundImage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getBackgroundImage() {
      if (!this.showBackgroundImage) {
        return
      }
      return { imageUrl: `https:${this.imageSource}` }
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.v-hero {
  height: 50vh;
  position: relative;

  .background-image {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .slot {
    z-index: 10;
  }
}

@media screen and (min-height: 700px) {
  .v-hero {
    height: 40vh;
  }
}
</style>
